import {Component} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {Observable} from "rxjs";
import {ProjectService} from "./project.service";
import {handleErrors} from "../misc/handle-errors.decorator";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {AppSettingsService} from "../app-settings/app-settings.service";

@Component({
  templateUrl: "./project-create-dialog.template.pug",
  providers: [
    ProjectService,
  ],
})
export class ProjectCreateDialogComponent extends DialogComponent<void, boolean> {
  public error: Error;
  static por190flag: boolean = true;
  public POR_190: boolean;
  static POR373_flag: boolean = false;
  public POR_373: boolean;
  regions = [
    {title: "AMS - Americas", value: "AMS"},
    {title: "APJ - Asia, Pacific and Japan", value: "APJ"},
    {title: "EMEA - Europe, Middle East and Africa", value: "EMEA"},
  ];
  targetSystemVal="";

  public form: FormGroup = new FormGroup({
    projectName: new FormControl(),
    region: new FormControl("", Validators.required),
    targetSystem: new FormControl(),
  });

  static showCreateDialog(dialogService: DialogService, POR190: boolean, por373: boolean ): Observable<boolean> {
    this.por190flag = POR190;
    this.POR373_flag = por373;
    return dialogService.addDialog(ProjectCreateDialogComponent, undefined, {backdropColor: "rgba(0, 0, 0, 0.5)"});
  }

  async ngOnInit() {
    this.POR_190 = ProjectCreateDialogComponent.por190flag;
    this.POR_373 = ProjectCreateDialogComponent.POR373_flag;
  }

  public onChangeTarget() {
    const {projectName} = this.form.getRawValue();
    if (projectName && projectName.length > 40) {
      this.form.controls["projectName"].setValue(projectName.substring(0, 40));
    }
  }

  public onChangeRegion() {
    if (this.form.get("region").value !== "AMS") {
      this.form.controls["targetSystem"].setValue("");
    }
  }

  cancel(): void {
    this.result = false;
    this.close();
  }

  @handleErrors()
  async save(): Promise<void> {
    const form = this.form.getRawValue();
    await this.projectService.create(form.projectName.trim(), form.region, form.targetSystem).toPromise();
    this.result = true;
    this.close();
  }

  constructor(
    public dialogService: DialogService,
    public projectService: ProjectService,
    public appSettingsService: AppSettingsService,
  ) {
    super(dialogService);
  }
}
